var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 55.01 55.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: #051b20;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n        mix-blend-mode: multiply;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 36.37,
    y1: 1.76,
    x2: 31.7,
    y2: 7.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f8a84a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f2935a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e77174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d94498"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.16,
    y1: 39.32,
    x2: 31.32,
    y2: 4.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d3d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#5f55a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#658cca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#69aedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6bbbe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d94498"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 27.17,
    y1: 12.42,
    x2: 26.59,
    y2: 2.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#85879a",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#e4e4e8",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.61,
    y1: 53.47,
    x2: 35.78,
    y2: 15.82,
    gradientTransform: "translate(2.05 .21) rotate(-.42) scale(.98 1.02) skewX(3.13)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 3.55,
    y1: 59.35,
    x2: 45.3,
    y2: 15.88,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 56.84,
    y1: 27.91,
    x2: 39.32,
    y2: 37.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 49.11,
    y1: 35.15,
    x2: 46.89,
    y2: 53.1,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M28.74.02c14.73-.2,13.02,12.09,13.02,12.09l-4.52-.04C39.02.9,28.23.91,27.59.88c-2.58-.1-6.42,2.4-5.97,11.04l-4.53-.04S18.35.15,28.74.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.16,0c12.31.11,10.81,12.29,10.81,12.29l-4.52-.04C36.23,1.09,28.23.84,27.59.88c-.96.06-7.16,0-8.76,11.23l-3.65-.1S15.84-.11,28.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28.16,0c12.31.11,10.81,12.29,10.81,12.29l-4.52-.04C36.23,1.09,28.23.84,27.59.88c-.96.06-7.16,0-8.76,11.23l-3.65-.1S15.84-.11,28.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.23,24.81c4.65-.32,8.37,3.72,8.34,9.07-.03,5.38-3.84,10.08-8.54,10.48-4.74.4-8.54-3.72-8.45-9.17.08-5.42,3.97-10.05,8.65-10.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5.17,53.56l35.73,2.31c2.46.16,11.19-3.72,11.19-3.72,1.96-.84-2.51-37.61-3.06-38.98-.13-.33-2.74-2.11-2.73-2.08h-.74s-35.92.34-35.92.34c-1.53.01-2.86.76-3.03,1.7L.12,49.05c-.7,3.82,1.62,4.18,5.04,4.52ZM10.11,35.71c-.04-7.03,5.27-13.22,11.84-13.86,6.56-.64,11.96,4.48,12.08,11.46.12,7.03-5.15,13.31-11.78,14-6.65.68-12.09-4.53-12.14-11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.78,52.72c-7.23,2.67-8.09,3.14-10.59,3.16-1.86.02-3.28-.14-3.28-.14,3.77-.89,4.73-2.92,5.07-5.98.49-4.4.7-9.64.76-14.73.08-7.53-.19-14.77-.44-18.56-.3-4.49,1.26-5.38,1.99-5.38,0,0,1.86-.37,2.73,2.08.48,1.33,4.21,22.81,5.67,32.72.07.44.13.86.18,1.25.4,2.83-.09,4.83-2.1,5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M52.78,52.72c-7.23,2.67-8.09,3.14-10.59,3.16-1.86.02-3.28-.14-3.28-.14,3.77-.89,4.73-2.92,5.07-5.98.49-4.4.7-9.64.76-14.73.58.04,1.19.11,1.84.2,5.78.79,7.61,7.76,8.12,10.66.14.77.18,1.25.18,1.25.4,2.83-.09,4.83-2.1,5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.19,55.88c.42,0,.8-.02,1.16-.06,2.14-.46,2.76-3.01,2.97-5.22.65-6.95.27-22.42-.68-32.8-.42-4.64.37-5.54,1.02-5.86,1.08-.53,1.85.21,1.85.21-.94-1.32-2.22-1.07-2.22-1.07-.74,0-2.29.89-1.99,5.38.42,6.36.89,22.37-.32,33.29-.34,3.06-1.3,5.09-5.07,5.98,0,0,1.41.15,3.28.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.58,19.82c-.17,1.67.98,2.94,2.57,2.84,1.59-.1,3.03-1.54,3.2-3.21.17-1.67-.98-2.94-2.57-2.83-1.59.1-3.02,1.54-3.2,3.21Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/Retail.03d4439db831fc90d08b356733235c09.svg";
export { ForwardRef as ReactComponent };